import PropTypes from 'prop-types';
import React from 'react';

function Estimate(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M17.6252 13.875H15.931C15.6714 13.8752 15.4199 13.9657 15.2197 14.131C15.0195 14.2963 14.8831 14.5262 14.8338 14.7811C14.7845 15.036 14.8255 15.3002 14.9497 15.5282C15.0738 15.7562 15.2735 15.9339 15.5143 16.0308L17.2343 16.7192C17.4752 16.8161 17.6749 16.9938 17.7991 17.2218C17.9232 17.4498 17.9642 17.714 17.9149 17.9689C17.8657 18.2238 17.7292 18.4537 17.529 18.619C17.3288 18.7843 17.0773 18.8748 16.8177 18.875H15.1252"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M16.375 19.5V18.875"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M16.375 13.875V13.25"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        clipRule="evenodd"
        d="M16.375 21.375C19.1364 21.375 21.375 19.1364 21.375 16.375C21.375 13.6136 19.1364 11.375 16.375 11.375C13.6136 11.375 11.375 13.6136 11.375 16.375C11.375 19.1364 13.6136 21.375 16.375 21.375Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M6.375 10.7588H10.75"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M6.375 13.8838H8.875"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M6.375 17.0088H8.875"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        clipRule="evenodd"
        d="M10.125 21.375H3.875C3.54348 21.375 3.22553 21.2433 2.99112 21.0089C2.7567 20.7745 2.625 20.4565 2.625 20.125V7C2.625 6.66848 2.7567 6.35053 2.99112 6.11612C3.22553 5.8817 3.54348 5.75 3.875 5.75H7C7 4.9212 7.32924 4.12634 7.91529 3.54029C8.50134 2.95424 9.2962 2.625 10.125 2.625C10.9538 2.625 11.7487 2.95424 12.3347 3.54029C12.9207 4.12634 13.25 4.9212 13.25 5.75H16.375C16.7065 5.75 17.0245 5.8817 17.2589 6.11612C17.4933 6.35053 17.625 6.66848 17.625 7V8.875"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M10.125 5.75879C9.95241 5.75879 9.8125 5.61887 9.8125 5.44629C9.8125 5.2737 9.95241 5.13379 10.125 5.13379"
        fill="none"
        stroke={fill}
        strokeWidth="1.25"
      />
      <path
        d="M10.125 5.75879C10.2976 5.75879 10.4375 5.61887 10.4375 5.44629C10.4375 5.2737 10.2976 5.13379 10.125 5.13379"
        fill="none"
        stroke={fill}
        strokeWidth="1.25"
      />
    </svg>
  );
}

Estimate.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Estimate;
